import { workspaceApi } from '@/api/workspace/index.ts';
import type { AppDispatch, AppState } from '@/store/store.ts';
import { selectFullTab } from '@/store/workspace/selector.ts';

export async function shareCurrentTab({
  ownerEmail,
  users,
  getState,
  dispatch,
}: {
  ownerEmail: string;
  users: string[];
  getState: () => AppState;
  dispatch: AppDispatch;
}) {
  const tab = selectFullTab(getState());

  if (!tab || tab.isShared) {
    console.warn('try to share a tab, but either the tab is already shared or is not found', { tab });
    return;
  }

  return dispatch(
    workspaceApi.endpoints.shareTab.initiate({
      ...tab,
      ownerEmail,
      sharedWithEmails: users,
      tabId: tab.id,
      version: 'forex',
    }),
  );
}
